import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const PolicySection = ({ title, children, isExpandable = false, defaultExpanded = true }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  if (!isExpandable) {
    return (
      <section className="mb-8">
        <h2 className="text-2xl font-poppins font-bold text-primary mb-4 flex items-center">
          <div className="w-2 h-8 bg-gradient-to-b from-primary to-accent rounded-full mr-3"></div>
          {title}
        </h2>
        <div className="text-text-primary leading-relaxed">
          {children}
        </div>
      </section>
    );
  }

  return (
    <section className="mb-6 border border-border rounded-lg overflow-hidden liquid-shadow">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full px-6 py-4 bg-surface hover:bg-muted brand-transition flex items-center justify-between text-left"
      >
        <h3 className="text-lg font-poppins font-semibold text-primary">{title}</h3>
        <Icon 
          name={isExpanded ? "ChevronUp" : "ChevronDown"} 
          size={20} 
          className="text-accent brand-transition"
        />
      </button>
      {isExpanded && (
        <div className="px-6 py-4 bg-card text-text-primary leading-relaxed">
          {children}
        </div>
      )}
    </section>
  );
};

export default PolicySection;